import { observer } from 'mobx-react-lite';
import {
    acTransactionHeadline,
    acTransactionBodyText,
    acTeachingBubblePrimaryBtnLabel,
    acTeachingBubbleSecondaryBtnLabel,
} from './ActionableMessageTeachingUI.locstring.json';
import loc from 'owa-localize';
import { ActionableMessageTeachingBubble } from './ActionableMessageTeachingBubble';
import { ButtonType, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { IImageProps } from 'office-ui-fabric-react/lib/Image';
import { LightningId } from 'owa-lightning-v2';
import { getPackageBaseUrl } from 'owa-config';

import * as React from 'react';
import { resolve as urlResolve } from 'url';
import {
    EVENTS,
    logTeachingEvent,
    teachingUITrace,
    URI,
    initilizeTeachingUITrace,
} from '../utils/actionableMessagesTeachingUIUtils';

export interface ActionableMessageTeachingUIProps {
    target: () => HTMLElement;
    acCorrelationId: string;
    messageId: string;
    actionType: string;
}

export default observer(function ActionableMessageTeachingUI(
    props: ActionableMessageTeachingUIProps
) {
    React.useEffect(() => {
        initilizeTeachingUITrace({
            adaptiveCardCorrelationId: props.acCorrelationId,
            messageId: props.messageId,
            tuiType: props.actionType,
        });
    }, []);
    const lightUpTeachingBubble = (lightup: () => void) => {
        logTeachingEvent(EVENTS.TRIGGERED, teachingUITrace());
        lightup();
    };
    return (
        props.actionType == 'Transaction' && (
            <ActionableMessageTeachingBubble
                target={props.target}
                when={lightUpTeachingBubble}
                gotItBtn={gotItButton('TeachingBubble')}
                learnMoreBtn={learnMoreButton('TeachingBubble')}
                learnMoreBtnUri={URI[props.actionType] || undefined}
                headline={loc(acTransactionHeadline)}
                bodyText={loc(acTransactionBodyText)}
                hasSmallHeadline={true}
                lid={LightningId.ActionableMessageTeachingUiTeachingBubblePolicy}
            />
        )
    );
});

function gotItButton(onClickEvent?: any): IButtonProps {
    return {
        buttonType: ButtonType.primary,
        children: loc(acTeachingBubblePrimaryBtnLabel),
        onClick: onClickEvent,
    };
}

export function learnMoreButton(onClickEvent?: any): IButtonProps {
    return {
        buttonType: ButtonType.normal,
        children: loc(acTeachingBubbleSecondaryBtnLabel),
        onClick: onClickEvent,
    };
}

export function calloutIllustration(source: string): IImageProps {
    return {
        src: urlResolve(getPackageBaseUrl(), source),
    };
}
